import Loading from 'vue-loading-overlay';
import { Component, Prop, Vue } from 'vue-property-decorator';
import requestChangesMutation from '../../mutations/requestChanges';
import transformToCart from '../../mutations/transformToCart';
import updateSuggestionMutation from '../../mutations/updateSuggestionState';
import summaryQuery from '../../queries/suggestionsListSummary';
import SectionTitle from '../shared/sectionTitle.vue';
import SingleInputDialog from '../shared/singleInputDialog.vue';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import SuggestionsListEntries from '../shared/suggestionsListEntries.vue';
import SuggestionsListSideBar from '../shared/suggestionsListSideBar.vue';
import AcceptRejectForm from './acceptRejectForm.vue';

@Component({
  components: {
    Loading,
    AcceptRejectForm,
    SuggestionsListSideBar,
    SingleMainContainer,
    SingleInputDialog,
    SuggestionsListEntries,
    SectionTitle,
  },
})
export default class SuggestionsListViewer extends Vue {
  @Prop() public suggestionsListId!: string;

  public acceptRejectWaiting = false;

  public readonly suggestionsListSummaryQuery = summaryQuery;

  public get suggestionsListSummaryQueryVariables() {
    return {
      suggestionsListId: this.suggestionsListId,
    };
  }

  public async updateCode(
    entryId: string,
    code: string,
    licenseId: string,
    count: number
  ): Promise<void> {
    console.log('hello');
    this.acceptRejectWaiting = true;
    try {
      await this.$apollo.mutate({
        mutation: updateSuggestionMutation,
        refetchQueries: [
          {
            query: (this.$refs.entriesComp as any).suggestionsQuery,
            variables: (this.$refs.entriesComp as any)
              .suggestionsQueryVariables,
          },
          {
            query: this.suggestionsListSummaryQuery,
            variables: this.suggestionsListSummaryQueryVariables,
          },
        ],
        variables: {
          entryId,
          code,
          licenseId,
          count,
          suggestionsListId: this.suggestionsListId,
        },
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.acceptRejectWaiting = false;
    }
  }

  public async handleRequestChangesDialogOk(val: string): Promise<void> {
    const loader = this.$loading.show();
    try {
      await this.$apollo.mutate({
        mutation: requestChangesMutation,
        refetchQueries: [
          {
            query: this.suggestionsListSummaryQuery,
            variables: this.suggestionsListSummaryQueryVariables,
          },
        ],
        variables: {
          message: val,
          suggestionsListId: this.suggestionsListId,
        },
      });
    } finally {
      loader.hide();
    }
  }

  public async handleTransformToCartClick(val: string) {
    await this.$apollo.mutate({
      mutation: transformToCart,
      refetchQueries: [
        {
          query: this.suggestionsListSummaryQuery,
          variables: this.suggestionsListSummaryQueryVariables,
        },
      ],
      variables: {
        suggestionsListId: this.suggestionsListId,
      },
    });
    //this.$router.push('/');
  }

  public handleRequestChangesClick() {
    const dialog = this.getDialog();
    dialog.show();
  }

  private getDialog(): any {
    return this.$refs.inputDialog;
  }
}
